import { render, staticRenderFns } from "./roomTypeList.vue?vue&type=template&id=351e5b9d&scoped=true"
import script from "./roomTypeList.vue?vue&type=script&lang=js"
export * from "./roomTypeList.vue?vue&type=script&lang=js"
import style0 from "./roomTypeList.vue?vue&type=style&index=0&id=351e5b9d&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e5b9d",
  null
  
)

export default component.exports